import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import MegaMenu from "./MegaMenu";
import { Link } from "react-router-dom";
import logo_1 from "../assets/img/entry-logo.png";
import logo from "../assets/img/banner/logo.png";
import megaImgRanger from "../assets/img/megaMenu-ranger.png";
import menuImgProducts from "../assets/img/megaMenu-products.png";
import menuImgLighting from "../assets/img/megaMenu-lighting.png";
import menuImgSoftware from "../assets/img/megaMenu-software.png";
import menuImgSolutions from "../assets/img/megaMenu-solutions.png";

// 解決方案圖片
import filmImg from "../pages/Home/components/img/film.webp";
import batteryImg from "../pages/Home/components/img/battery.webp";
import pcbImg from "../pages/Home/components/img/pcb.webp";
import nonwovenImg from "../pages/Home/components/img/nonwoven.webp";
import metalImg from "../pages/Home/components/img/metal.webp";
import paperImg from "../pages/Home/components/img/paper.webp";
import solarImg from "../pages/Home/components/img/solar.webp";
import generalImg from "../pages/Home/components/img/glass.webp";
import { changeAppLanguage } from "../i18n";

const SHOW_SOLUTIONS = true;
// 將表面檢測系統暫時隱藏（mark 掉）
const SHOW_INSPECTION = false;

function Header() {
  const { t, i18n } = useTranslation();
  const [activeMegaMenu, setActiveMegaMenu] = useState(null);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [mobileDropdown, setMobileDropdown] = useState({ products: false, solutions: false });
  const [isLangOpen, setIsLangOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const closeTimerRef = useRef(null);
  const langRef = useRef(null);
  const productsRef = useRef(null);
  const solutionsRef = useRef(null);

  const toggleMobileMenu = () => setIsMobileOpen(o => !o);
  const toggleMobileDropdown = key =>
    setMobileDropdown(prev => ({ ...prev, [key]: !prev[key] }));
  const openMega = name => {
    if (name === "solutions" && !SHOW_SOLUTIONS) return;
    clearTimeout(closeTimerRef.current);
    setActiveMegaMenu(name);
  };
  const scheduleClose = () => {
    clearTimeout(closeTimerRef.current);
    closeTimerRef.current = setTimeout(() => setActiveMegaMenu(null), 120);
  };
  const changeLanguage = lng => {
    changeAppLanguage(lng); // persist to localStorage
    setIsLangOpen(false);
  };
  const currentLang = i18n.language === "zh" ? "繁體中文" : "English";

  const getMegaMenuContent = menuName => {
    switch (menuName) {
      case "products": {
        const categories = [
          // ...existing code...
          // 將表面檢測系統項目暫時隱藏
          // SHOW_INSPECTION && { name: t("megaMenu.products.category1.title"), image: megaImgRanger, link: "/products/inspection" },
          { name: t("megaMenu.products.category2.title"), image: menuImgProducts, link: "/products/camera" },
          { name: t("megaMenu.products.category3.title"), image: menuImgLighting, link: "/products/lighting" },
          { name: t("megaMenu.products.category4.title"), image: menuImgSoftware, link: "/products/software" },
          { name: t("megaMenu.products.category5.title"), image: menuImgSolutions, link: "/products/solutions" }
        ].filter(Boolean);
        return { type: "products", categories };
      }
      case "solutions":
        if (!SHOW_SOLUTIONS) return null;
        return {
          type: "solutions",
          categories: [
            { id: "film", name: t("solutions.film.title"), image: filmImg, link: "/solutions/film" },
            { id: "battery", name: t("solutions.battery.title"), image: batteryImg, link: "/solutions/battery" },
            { id: "pcb", name: t("solutions.pcb.title"), image: pcbImg, link: "/solutions/pcb" },
            { id: "nonwoven", name: t("solutions.nonwoven.title"), image: nonwovenImg, link: "/solutions/nonwoven" },
            { id: "metal", name: t("solutions.metal.title"), image: metalImg, link: "/solutions/metal" },
            { id: "paper", name: t("solutions.paper.title"), image: paperImg, link: "/solutions/paper" },
            { id: "solar", name: t("solutions.solar.title"), image: solarImg, link: "/solutions/solar" },
            { id: "general", name: t("solutions.general.title"), image: generalImg, link: "/solutions/glass" }
          ]
        };
      default:
        return null;
    }
  };

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMobileAll = () => {
    setIsMobileOpen(false);
    setMobileDropdown({ products: false, solutions: false });
  };

  return (
    <header
      className={`z-[99] fixed top-0 right-0 left-0 transition-all duration-300 ${
        isScrolled ? "bg-black bg-opacity-70 shadow-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto px-4 sm:px-6 lg:px-16">
        <div className="flex justify-between h-16 items-center">
          <div className="flex-shrink-0 flex items-center space-x-3">
            <a href="/"><img className="h-8 sm:h-12 w-auto" src={logo_1} alt="Logo" /></a>
            <a href="/"><img className="h-8 sm:h-12 w-auto" src={logo} alt="Logo" /></a>
          </div>

          <nav className="hidden lg:flex space-x-6 items-center" role="navigation">
            <a href="/visual" className="text-white hover:text-blue-600">{t("nav.home")}</a>

            <div
              ref={productsRef}
              onMouseEnter={() => openMega("products")}
              onMouseLeave={scheduleClose}
              className="relative"
            >
              <button type="button" className="text-white hover:text-blue-600 focus:outline-none">
                {t("nav.products")}
              </button>
            </div>

            {SHOW_SOLUTIONS && (
              <div
                ref={solutionsRef}
                onMouseEnter={() => openMega("solutions")}
                onMouseLeave={scheduleClose}
                className="relative"
              >
                <button type="button" className="text-white hover:text-blue-600 focus:outline-none">
                  {t("nav.solutions")}
                </button>
              </div>
            )}

            <Link to="/about-us" className="text-white hover:text-blue-600">
              {t("nav.about")}
            </Link>
            <Link to="/news" className="text-white hover:text-blue-600">
              {t("nav.news")}
            </Link>
            <a href="/contact" className="text-white hover:text-blue-600">
              {t("nav.contact")}
            </a>

            <div className="relative" ref={langRef}>
              <button
                type="button"
                onClick={() => setIsLangOpen(!isLangOpen)}
                className="text-white hover:text-blue-600 focus:outline-none flex items-center space-x-1"
                aria-haspopup="true"
                aria-expanded={isLangOpen}
              >
                <span>🌐</span>
                <span>{currentLang}</span>
                <svg
                  className={`w-4 h-4 transition-transform ${isLangOpen ? "rotate-180" : ""}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isLangOpen && (
                <div className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg py-1 z-50">
                  <button
                    type="button"
                    onClick={() => changeLanguage("zh")}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    繁體中文
                  </button>
                  <button
                    type="button"
                    onClick={() => changeLanguage("en")}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    English
                  </button>
                </div>
              )}
            </div>
          </nav>

          <div className="lg:hidden">
            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              aria-expanded={isMobileOpen}
              aria-controls="mobile-nav"
              aria-label="Toggle navigation"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMobileOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {isMobileOpen && (
        <div
          id="mobile-nav"
          className="md:hidden bg-black bg-opacity-90 border-t border-gray-700"
          role="navigation"
        >
          <nav className="px-4 py-4 flex flex-col space-y-3">
            <a
              href="/visual"
              onClick={closeMobileAll}
              className="text-white hover:text-blue-400"
            >
              {t("nav.home")}
            </a>

            <button
              type="button"
              onClick={() => toggleMobileDropdown("products")}
              className="flex justify-between items-center text-white hover:text-blue-400"
              aria-expanded={mobileDropdown.products}
              aria-controls="mobile-products-sub"
            >
              <span>{t("nav.products")}</span>
              <span>{mobileDropdown.products ? "−" : "+"}</span>
            </button>
            {mobileDropdown.products && (
              <div id="mobile-products-sub" className="ml-3 flex flex-col space-y-2">
                {/* 表面檢測系統暫時隱藏 */}
                {/* <a href="/products/inspection" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">表面檢測系統</a> */}
                <a href="/products/camera" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">工業相機</a>
                <a href="/products/lighting" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">光源</a>
                <a href="/products/software" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">軟體</a>
                <a href="/products/solutions" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">標籤機</a>
              </div>
            )}

            {SHOW_SOLUTIONS && (
              <>
                <button
                  type="button"
                  onClick={() => toggleMobileDropdown("solutions")}
                  className="flex justify-between items-center text-white hover:text-blue-400"
                  aria-expanded={mobileDropdown.solutions}
                  aria-controls="mobile-solutions-sub"
                >
                  <span>{t("nav.solutions")}</span>
                  <span>{mobileDropdown.solutions ? "−" : "+"}</span>
                </button>
                {mobileDropdown.solutions && (
                  <div id="mobile-solutions-sub" className="ml-3 flex flex-col space-y-2">
                    <a href="/solutions/film" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">{t("solutions.film.title")}</a>
                    <a href="/solutions/battery" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">{t("solutions.battery.title")}</a>
                    <a href="/solutions/pcb" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">{t("solutions.pcb.title")}</a>
                    <a href="/solutions/nonwoven" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">{t("solutions.nonwoven.title")}</a>
                    <a href="/solutions/metal" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">{t("solutions.metal.title")}</a>
                    <a href="/solutions/paper" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">{t("solutions.paper.title")}</a>
                    <a href="/solutions/solar" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">{t("solutions.solar.title")}</a>
                    <a href="/solutions/glass" onClick={closeMobileAll} className="text-gray-300 hover:text-blue-300">{t("solutions.general.title")}</a>
                  </div>
                )}
              </>
            )}

            <Link to="/about-us" onClick={closeMobileAll} className="text-white hover:text-blue-400">
              {t("nav.about")}
            </Link>
            <Link to="/news" onClick={closeMobileAll} className="text-white hover:text-blue-400">
              {t("nav.news")}
            </Link>
            <a href="/contact" onClick={closeMobileAll} className="text-white hover:text-blue-400">
              {t("nav.contact")}
            </a>

            <div className="pt-2 border-t border-gray-700">
              <button
                type="button"
                onClick={() => { changeLanguage("zh"); closeMobileAll(); }}
                className="block w-full text-left text-white hover:text-blue-400 py-1"
              >
                繁體中文
              </button>
              <button
                type="button"
                onClick={() => { changeLanguage("en"); closeMobileAll(); }}
                className="block w-full text-left text-white hover:text-blue-400 py-1"
              >
                English
              </button>
            </div>
          </nav>
        </div>
      )}

      <MegaMenu
        isOpen={activeMegaMenu === "products"}
        menuContent={getMegaMenuContent("products")}
        onMouseEnter={() => openMega("products")}
        onMouseLeave={scheduleClose}
        anchorRef={productsRef}
      />
      {SHOW_SOLUTIONS && (
        <MegaMenu
          isOpen={activeMegaMenu === "solutions"}
          menuContent={getMegaMenuContent("solutions")}
          onMouseEnter={() => openMega("solutions")}
          onMouseLeave={scheduleClose}
          anchorRef={solutionsRef}
        />
      )}
    </header>
  );
}

export default Header;
